import React from 'react'
import Box from '@mui/joy/Box'
import Slider from '@mui/joy/Slider'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'
import type { SliderProps } from '@mui/joy/Slider'

import type { MinMaxRange } from '../types'
import { DEFAULT_WEIGHT_RANGE } from '../weight-range'

function valueText(value: number) {
    return `${value}t`
}

function formatTonnes(value: number) {
    return `${Number(value.toFixed(2))}t`
}

export default function WeightSlider({
    value,
    handleChange,
    range,
}:{
    value: number | null,
    handleChange: SliderProps['onChange'],
    range: MinMaxRange | null,
}) {

    const rangeMin = range?.min ?? DEFAULT_WEIGHT_RANGE.min
    const rangeMax = range?.max ?? DEFAULT_WEIGHT_RANGE.max

    const MARK_COUNT = 5

    const marks = Array.from({ length: MARK_COUNT }, (_, index) => {
        const value = rangeMin + ((rangeMax - rangeMin) / (MARK_COUNT - 1)) * index

        return {
            value,
            label: formatTonnes(value),
        }
    })

    const { t } = useTranslation()
    const label = t('filters.carWeight')

    return (
        <Box>
            <Typography level='title-md'>{label}</Typography>
            <Box px={2.5}>
                <Slider
                    aria-label={label}
                    value={value ?? rangeMin}
                    onChange={handleChange}
                    getAriaValueText={valueText}
                    step={0.05}
                    valueLabelDisplay="auto"
                    valueLabelFormat={valueText}
                    marks={marks}
                    min={rangeMin}
                    max={rangeMax}
                    name="minWeight"
                    sx={{
                        "--Slider-thumbSize": "18px"
                    }}
                />
            </Box>
        </Box>
    )
}
